import { z } from 'zod';

import {
	type BulkUploadItem,
	type BulkUploadResponse,
	bulkUploadItemSchema,
	createBulkUploadResponseSchema,
} from '@apple/utils/files/models/bulk-upload';

import { type ProductKey, productKeySchema } from '@apple/features/product/models/product';
import type { StoreId } from '@apple/features/store/models';

/** @see AppleRetail.Web.Areas.StoreEvents.Models.ProductBulkImportItemModel **/
export type EventItemUploadModel = BulkUploadItem & {
	storeId: StoreId;
	categoryName: string;
	partNumber: ProductKey;
	quantity: string;
	comment: string | null;
};
export type EventItemsUploadResponse = BulkUploadResponse<EventItemUploadModel>;

/** @see AppleRetail.Web.Areas.StoreEvents.Models.ProductBulkImportItemModel **/
export const eventItemUploadSchema = bulkUploadItemSchema.extend({
	storeId: z.string(),
	categoryName: z.string(),
	partNumber: productKeySchema,
	quantity: z.string(),
	comment: z.string().nullable(),
});
export const eventItemsUploadResponseSchema = createBulkUploadResponseSchema(
	eventItemUploadSchema,
) satisfies z.ZodType<EventItemsUploadResponse>;
